// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1fAIW","row":"Node_row__1anOm","label":"Node_label__EhEx4","footer":"Node_footer__KUc0L"};